// extracted by mini-css-extract-plugin
export default {"wrapper":"TextButton_wrapper__5SdNh","navLink":"TextButton_navLink__meYoz"};